import React from 'react';
import './runwayc.css'

const Runwayc = (props) => {
    return ( <>
    <div className='runwaycdiv'>
        <h6 className='number'>{props.numbbb}</h6>
        <div className='runwaydiv2'>
            <h6 className='runwaycollectiontext'>{props.runwaycc}</h6>
            <div className='runwaydiv3'>
                <img className='photorunway' src={props.photorunway} alt="" />
                <div className='runwaydiv4'>
                    <h6 className='springtext'>{props.springtext}</h6>
                    <div className='arrowrunwayy'></div>
                </div>
            </div>
        </div>
    </div>
    </> );
}
 
export default Runwayc;